import { fmtDate, inr } from "./api";

const BANK = [["A/c name", "bank_account_name"], ["Bank", "bank_name"], ["A/c no.", "bank_account_number"], ["IFSC", "bank_ifsc"], ["Branch", "bank_branch"]];

export const payInfoText = (s, ref) => {
  if (!s) return "";
  const bank = BANK.filter(([, k]) => s[k]).map(([l, k]) => `${l}: ${s[k]}`);
  if (!s.upi_id && !bank.length) return "";
  const lines = ["*How to pay*"];
  if (s.upi_id) lines.push(`UPI: ${s.upi_id}`);
  lines.push(...bank);
  if (s.payment_note) lines.push(s.payment_note);
  if (ref) lines.push(`Please mention ${ref} as the payment reference.`);
  return `\n\n${lines.join("\n")}`;
};

export const feedbackText = (b, s) =>
  `Hi ${b.customer_name}, thank you so much for travelling to the Andaman Islands with ${s?.company_name || "Ocean Wings Travel"}! ` +
  `We hope you had a wonderful time and made beautiful memories.\n\n` +
  (s?.review_link ? `Could you please take a minute to share your experience in a Google review? It really helps us:\n${s.review_link}\n\n` : "") +
  `We would also love to see your trip photos. Just reply here with your favourite pictures.\n\nThank you, and we hope to welcome you again soon!`;

export const briefingText = (b, s, f) => {
  const packing = (s?.packing_checklist || "").split("\n").map((x) => x.trim()).filter(Boolean);
  const parts = [`Hi ${b.customer_name}! Your Andaman trip with ${s?.company_name || "Ocean Wings Travel"} starts on *${fmtDate(b.travel_date)}*` +
    `${b.package_name ? ` (${b.package_name})` : ""}, booking ${b.booking_no}. Here is your trip briefing:`];
  if (f.pickup.trim()) parts.push(`*Pickup*\n${f.pickup.trim()}`);
  if (f.ferry.trim()) parts.push(`*Ferry schedule*\n${f.ferry.trim()}`);
  if (packing.length) parts.push(`*What to pack*\n${packing.map((x) => `• ${x}`).join("\n")}`);
  if (f.notes.trim()) parts.push(`*Notes*\n${f.notes.trim()}`);
  let text = parts.join("\n\n");
  if (b.balance_due > 0) text += `\n\n*Balance due:* ${inr(b.balance_due)}${payInfoText(s, b.booking_no)}`;
  return `${text}\n\nFor any help, WhatsApp us on ${s?.whatsapp || ""}. Have a wonderful trip!`;
};
